<template>
    <div id="errorReport" class="d-flex flex-column">
        <md-field>
            <label>{{ $t("message.writeFeedback") }}</label>
            <md-textarea v-model="errorMsg"></md-textarea>
        </md-field>
        <md-button
            class="align-self-end md-raised md-primary"
            @click="handleSendErrorMsg"
            style="min-width: 160px"
            :disabled="isSending"
        >
            <md-progress-spinner
                v-if="isSending"
                class="md-accent text-light"
                :md-diameter="30"
                md-mode="indeterminate"
            ></md-progress-spinner>
            <span v-else>{{ $t("message.sendFeedback") }}</span>
        </md-button>
    </div>
</template>

<script>
import { dataURItoBlob } from "./util/dataURItoBlob";
import { uploadAsset } from "../api/assetUpload";
import mimeTypes from "./util/mimeTypes";
import axios from "axios";
import { log2 } from "../utils/log2";
import { mapState } from "vuex";
import { reportError } from "../api/errorReport";
import { getExtensionFromFileName } from "../utils/utils";

const log = log2("ErrorReport");
export default {
    name: "ErrorReport",
    props: {
        fileUrl: {
            type: String,
            default: "",
            required: true,
        },
    },
    data() {
        return {
            errorMsg: "",
            isSending: false,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
        }),
    },
    methods: {
        async errorRequest(payload) {
            const response = await reportError(payload);
            log("handleSendErrorMsg 2", response);
            if (response.data === true) {
                this.$toasted.show(this.$t("message.feedbackSuccessful"), {
                    duration: 3000,
                    position: "bottom-center",
                });
                this.$emit("changeVisibility");
            }
        },

        async handleSendErrorMsg() {
            try {
                this.isSending = true;
                if (this.fileUrl) {
                    const blobData = dataURItoBlob(this.fileUrl);
                    log("handleSendErrorMsg is here ", { URL: this.fileUrl, blob: blobData });
                    let file = blobData;
                    const fileType = getExtensionFromFileName(this.fileUrl);
                    let path = `${this.site._id}/error/${this.user._id}`;
                    let { data } = await uploadAsset({
                        path,
                        mime: file.type,
                        name: file.name,
                        ext: mimeTypes[file.type] || fileType || "supsis",
                    });
                    log("file", { file, data });

                    await axios({
                        method: data.method,
                        url: data.url,
                        data: file,
                    });
                    const imageUrl = `https://static.supsis.live/${data.asset.path}${data.asset.id}.${data.asset.ext}`;
                    log("handleSendErrorMsg imageUrl", imageUrl);
                    const payload = {
                        message: this.errorMsg,
                        reporterType: "representative",
                        imageUrl,
                    };
                    await this.errorRequest(payload);
                } else {
                    const payload = {
                        message: this.errorMsg,
                        reporterType: "representative",
                    };
                    await this.errorRequest(payload);
                }
                this.isSending = false;
            } catch (e) {
                this.$toasted.error(this.$t("message.feedbackFailed"), {
                    duration: 3000,
                    position: "bottom-center",
                });
                this.isSending = false;
            }
        },
    },
};
</script>

<style scoped></style>
